import { getSessionManager } from './session';

export const getAuthReturnCabinetAccountId = (selectedAccountId?: null | string): null | string =>
  selectedAccountId ?? getSessionManager().accountId;

export const redirectToCurrentAuthSigninUrl = (cabinet?: null | string): void => {
  getSessionManager().safeRedirectToAuth(getAuthReturnCabinetAccountId(cabinet));
};
